module.exports = __webpack_public_path__ + "img/trades.be69a47c.jpg";